module.exports = __webpack_public_path__ + "img/1951-Hansberry.baa8d171.png";